import { NOT_APPLICABLE_LABEL } from '@/constants';
import * as styles from './styles';
import { UnitSystemEnum } from '@/__generated__/graphql';

export type CustomBlockHighlightMarkerProps = {
  name: string | undefined;
  totalSurfaceArea: number | undefined;
  ri4plusri5: number | undefined;
  unit: UnitSystemEnum;
};

export const CustomBlockHighlightMarker = ({
  name,
  ri4plusri5,
  totalSurfaceArea,
  unit,
}: CustomBlockHighlightMarkerProps) => {
  const unitLabel = unit === UnitSystemEnum.Imperial ? 'ft²' : 'm²';
  return (
    <div style={styles.containerStyle}>
      <div style={styles.panelStyle}>
        <div style={styles.blockTitleStyle}>{name || NOT_APPLICABLE_LABEL}</div>

        <div style={styles.infoRowStyle}>
          <span style={styles.infoLabelStyle}>Total surface area:</span>
          <span style={styles.infoValueStyle}>
            {totalSurfaceArea || NOT_APPLICABLE_LABEL} {unitLabel}
          </span>
        </div>

        <div style={styles.lastRowStyle}>
          <span style={styles.infoLabelStyle}>Ri4 & Ri5</span>
          <span style={styles.infoValueStyle}>
            {ri4plusri5 || NOT_APPLICABLE_LABEL} {unitLabel}
          </span>
        </div>
      </div>
    </div>
  );
};
